import { CEFR_LEVELS } from '../cefr';

export const ENGLISH_IQ_SUB_BANDS = [
  { subBand: 'A1.1', cefr: CEFR_LEVELS[0], minScore: 60, maxScore: 69 },
  { subBand: 'A1.2', cefr: CEFR_LEVELS[0], minScore: 70, maxScore: 79 },
  { subBand: 'A2.1', cefr: CEFR_LEVELS[1], minScore: 80, maxScore: 89 },
  { subBand: 'A2.2', cefr: CEFR_LEVELS[1], minScore: 90, maxScore: 99 },
  { subBand: 'B1.1', cefr: CEFR_LEVELS[2], minScore: 100, maxScore: 107 },
  { subBand: 'B1.2', cefr: CEFR_LEVELS[2], minScore: 108, maxScore: 114 },
  { subBand: 'B2.1', cefr: CEFR_LEVELS[3], minScore: 115, maxScore: 122 },
  { subBand: 'B2.2', cefr: CEFR_LEVELS[3], minScore: 123, maxScore: 129 },
  { subBand: 'C1.1', cefr: CEFR_LEVELS[4], minScore: 130, maxScore: 136 },
  { subBand: 'C1.2', cefr: CEFR_LEVELS[4], minScore: 137, maxScore: 142 },
  { subBand: 'C2', cefr: CEFR_LEVELS[5], minScore: 143, maxScore: 150 },
] as const;
